export interface BootOptions {}
